import React, { useState, useMemo } from 'react';
import { useOutletContext } from 'react-router-dom';
import Icon from '../../components/dashboard/DashboardIcons';
import { PageHead } from './finance/shared';

const CATEGORIES = [
  {
    key: 'players', title: 'اللاعبون', icon: 'users', featured: true,
    items: [
      { q: 'كيف أضيف لاعباً جديداً؟', a: 'من قائمة «اللاعبون» اضغط «إضافة لاعب»، وعبّئ الاسم، الفئة، المركز، تاريخ الميلاد، ورقم القميص، ثم احفظ.' },
      { q: 'كيف أطبع بطاقة اللاعب؟', a: 'من صف اللاعب اضغط أيقونة «بطاقة الباركود»، اختر الشكل (عرضي أو طولي)، ثم اضغط «طباعة البطاقة». تحتوي البطاقة على رمز QR يُستخدم لتسجيل الحضور.' },
      { q: 'كيف يعمل رمز QR في بطاقة اللاعب؟', a: 'يحمل الرمز رقم اللاعب الفريد داخل النظام، ويُمسح عبر كاميرا صفحة «الحضور والانصراف» لتسجيل حضوره تلقائياً.' },
      { q: 'كيف أستورد قائمة لاعبين دفعة واحدة؟', a: 'استخدم زر «استيراد ملف Excel» في أعلى صفحة اللاعبين، وحمّل القالب أولاً للتأكد من ترتيب الأعمدة الصحيح.' },
      { q: 'كيف أتابع حالة اشتراك اللاعب؟', a: 'تظهر حالة الاشتراك (ساري، ينتهي قريباً، منتهٍ) كشارة ملوّنة في قائمة اللاعبين وفي ملفه الشخصي.' },
    ],
  },
  {
    key: 'attendance', title: 'الحضور والانصراف', icon: 'clock', featured: true,
    items: [
      { q: 'كيف أسجّل حضور اللاعبين؟', a: 'من صفحة «الحضور والانصراف» اضغط «مسح بالكاميرا» ووجّه الكاميرا نحو رمز QR في بطاقة اللاعب، أو أدخل رقمه يدوياً.' },
      { q: 'هل يمكن مسح عدة بطاقات متتالية؟', a: 'نعم، تبقى الكاميرا مفتوحة وتسجّل كل بطاقة تلقائياً مع تنبيه صوتي/مرئي، دون الحاجة لإعادة فتحها.' },
      { q: 'كيف أستعرض سجل حضور يوم معيّن؟', a: 'اختر التاريخ من أعلى الصفحة، وستظهر قائمة الحاضرين والغائبين لتلك الفئة أو اليوم المحدد.' },
    ],
  },
  {
    key: 'finance', title: 'الإدارة المالية', icon: 'banknotes', featured: true,
    items: [
      { q: 'ما الفرق بين المصروفات والإيرادات؟', a: 'المصروفات تسجّل ما يُدفع (رواتب، مستلزمات...)، والإيرادات تسجّل ما يُقبض (اشتراكات، رسوم...). يظهر الفرق بينهما في «الملخص المالي».' },
      { q: 'كيف أنشئ فاتورة جديدة؟', a: 'من صفحة «الفواتير» اضغط «فاتورة جديدة»، حدد الجهة والمبلغ والبنود، ثم احفظ لطباعتها أو مشاركتها.' },
      { q: 'كيف تُحسب الرواتب؟', a: 'صفحة «الرواتب» تجمع الراتب الأساسي والبدلات المسجّلة لكل موظف من ملفه، ويمكنك مراجعتها وتصديرها شهرياً.' },
      { q: 'كيف أسجّل سلفة لموظف وكيف تُخصم من راتبه؟', a: 'من «الرواتب والسلف» أضف سلفة جديدة وحدد قيمتها وعدد الأقساط، وتُخصم تلقائياً من راتب الموظف شهرياً حتى تنتهي، دون أن تُسجَّل كمصروف إضافي عند الخصم (فقط عند منحها أول مرة).' },
      { q: 'من يمكنه رؤية البيانات المالية؟', a: 'فقط المدير والأدوار المالية المصرَّح لها (كالمحاسب) — يظهر ذلك في صلاحيات كل مستخدم من «الإعدادات».' },
    ],
  },
  {
    key: 'seasons', title: 'المواسم والأرشيف', icon: 'calendar',
    items: [
      { q: 'ما هو مبدّل المواسم الظاهر بأعلى الصفحة؟', a: 'أيقونة التقويم بأعلى الشاشة تتيح لك التبديل بين مواسمك (مثل موسم 2025-2026)، أو عرض «الأرشيف الكامل» لجميع المواسم معاً. البيانات المعروضة (لاعبون، فرق، مباريات، حضور، تقارير) تتغيّر حسب الموسم المختار.' },
      { q: 'كيف أنشئ موسماً جديداً أو أرشّف موسماً سابقاً؟', a: 'اضغط أيقونة الترس ⚙ داخل قائمة المواسم للانتقال مباشرة لصفحة إدارة المواسم، ومنها يمكنك إنشاء موسم جديد، تفعيله، أو إغلاق وأرشفة موسم منتهٍ.' },
      { q: 'هل تُفقد بيانات اللاعبين عند بدء موسم جديد؟', a: 'لا، تبقى كل بياناتهم محفوظة. يمكنك ترحيل اللاعبين والفرق من الموسم السابق إلى الموسم الجديد بضغطة واحدة، أو إبقاء البعض خارج الموسم الجديد إذا لزم.' },
    ],
  },
  {
    key: 'employees', title: 'الموظفون وعقود العمل', icon: 'briefcase',
    items: [
      { q: 'كيف أضيف موظفاً جديداً؟', a: 'من «الموظفون والإداريون» اضغط «إضافة موظف»، وحدد نوعه (إداري، طبي، أمن، خدمات)، والمسمى الوظيفي، والراتب، وتاريخ الانضمام.' },
      { q: 'كيف أطبع عقد عمل الموظف؟', a: 'من صف الموظف اضغط أيقونة «عقد العمل» لعرض عقد جاهز ببيانات الموظف وبنوده القانونية، ثم اطبعه.' },
      { q: 'كيف أضيف بنوداً خاصة في العقد؟', a: 'عند إضافة أو تعديل الموظف، اكتب كل بند إضافي في سطر مستقل بحقل «بنود إضافية للعقد»، وستظهر في نهاية العقد المطبوع تلقائياً.' },
      { q: 'كيف أطبع بطاقة تعريف الموظف؟', a: 'اضغط أيقونة «طباعة بطاقة الموظف» من صفه، واختر الشكل العرضي أو الطولي حسب الحاجة.' },
      { q: 'ماذا يحدث عند تعطيل موظف؟', a: 'يُنقل إلى حالة «موقوف» دون حذف أي من سجلاته أو بياناته، ويمكن إعادة تفعيله في أي وقت.' },
    ],
  },
  {
    key: 'teams', title: 'الفرق والفئات', icon: 'userGroup',
    items: [
      { q: 'ما الفرق بين الفريق والفئة؟', a: 'الفئة تمثل عمر اللاعبين (مثل تحت 12 سنة)، أما الفريق فهو تجمع تدريبي/تنافسي قد يضم لاعبين من فئة أو أكثر.' },
      { q: 'كيف أسند مدرباً لفريق؟', a: 'من صفحة «الفرق» افتح الفريق واختر المدرب من قائمة الطاقم التدريبي المسجَّل مسبقاً.' },
    ],
  },
  {
    key: 'matches', title: 'المباريات والبطولات', icon: 'calendar',
    items: [
      { q: 'كيف أسجّل مباراة جديدة؟', a: 'من «المباريات» اضغط «مباراة جديدة»، حدد الخصم والتاريخ والفئة، وسجّل النتيجة والأحداث بعد انتهائها.' },
      { q: 'كيف أنشئ بطولة؟', a: 'من «البطولات» أضف بطولة جديدة وحدد الفرق المشاركة والجدول، وتابع النتائج من نفس الصفحة.' },
      { q: 'أين أجد إحصائيات الهدافين؟', a: 'من «التقارير الفنية» تجد قوائم الهدافين وصناع اللعب والبطاقات، محدثة تلقائياً من أحداث المباريات المسجَّلة.' },
    ],
  },
  {
    key: 'reports', title: 'التقارير والإنجازات', icon: 'chart',
    items: [
      { q: 'ما الفرق بين التقارير والتقارير المالية؟', a: '«التقارير والإحصائيات» تغطي الأداء الرياضي العام، بينما «التقارير المالية» مخصصة للميزانية والمصروفات والإيرادات.' },
      { q: 'كيف أضيف إنجازاً للنادي أو لاعب؟', a: 'من صفحة «الإنجازات» اضغط «إضافة إنجاز» وحدد صاحبه (لاعب/فريق/منشأة) ووصفه وتاريخه.' },
    ],
  },
  {
    key: 'staff', title: 'الطاقم التدريبي والطبي', icon: 'whistle',
    items: [
      { q: 'كيف أستقطب مدرباً جديداً؟', a: 'من «استقطاب المدربين» يمكنك تصفح طلبات المدربين المستقلين المسجَّلين في تسيار ودعوتهم للانضمام لمنشأتك.' },
      { q: 'كيف أسجّل تقييم أداء لعضو الطاقم؟', a: 'من «تقييم الأداء» أضف تقييماً جديداً وحدد المعايير والدرجة والملاحظات لكل فرد.' },
    ],
  },
  {
    key: 'coach_studio', title: 'بوابة المدرب والعمل الفني', icon: 'field',
    items: [
      { q: 'أين أجد محرر الملعب التفاعلي؟', a: 'من «تدريبات الفرق» يمكن للمدرب بناء تمارين وخطط باستخدام محرر ملعب بالسحب والإفلات، وتصديرها كصورة أو PDF.' },
      { q: 'كيف أشارك خطة تدريبية مع فريق؟', a: 'بعد إنشاء الخطة، استخدم زر «مشاركة» وحدد الفريق أو الفئة المستهدفة، وتظهر لهم في «الخطط المشاركة».' },
      { q: 'كيف أسحب مشاركة خطة لاحقاً؟', a: 'من «الخطط المشاركة» اضغط «إلغاء المشاركة» لسحب الوصول فوراً دون حذف الخطة الأصلية.' },
    ],
  },
  {
    key: 'governance', title: 'مجلس الإدارة والحوكمة', icon: 'building',
    items: [
      { q: 'من يمكنه الوصول لصفحة مجلس الإدارة؟', a: 'هذه الصفحة خاصة بالأندية فقط (لا تظهر للأكاديميات)، وتُدار من قِبل المدير أو من يخوّله.' },
    ],
  },
  {
    key: 'settings', title: 'الإعدادات والاشتراك', icon: 'cog',
    items: [
      { q: 'كم تستمر الفترة التجريبية؟', a: 'تحصل كل منشأة جديدة على فترة تجريبية مجانية 30 يوماً كاملة الميزات، تبدأ من لحظة التسجيل.' },
      { q: 'ماذا يحدث عند انتهاء التجربة؟', a: 'يظهر تنبيه قبل الانتهاء بأيام، وبعد الانتهاء تحتاج للتواصل مع فريقنا لترقية باقتك ومواصلة استخدام لوحة التحكم.' },
      { q: 'كيف أغيّر شعار المنشأة أو اسمها؟', a: 'من «الإعدادات» يمكنك رفع شعار جديد وتحديث بيانات المنشأة الأساسية في أي وقت.' },
    ],
  },
  {
    key: 'support', title: 'المساعدة والدعم', icon: 'search',
    items: [
      { q: 'كيف أستخدم المساعد الذكي؟', a: 'اضغط أيقونة الدردشة في الزاوية، واختر تبويب «المساعد الذكي»، واكتب سؤالك ليردّ عليك فوراً على مدار الساعة.' },
      { q: 'متى أحوّل المحادثة لتذكرة دعم؟', a: 'إذا لم يحل المساعد الذكي مشكلتك، اضغط «حوّله إلى تذكرة دعم بشرية» داخل نافذة الدردشة، وسيتواصل معك فريقنا مباشرة.' },
    ],
  },
];

const AccordionItem = ({ item, testIdBase }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-slate-100 last:border-0" data-testid={testIdBase}>
      <button onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-right" data-testid={`${testIdBase}-toggle`}>
        <span className="text-sm font-semibold text-slate-800">{item.q}</span>
        <Icon name={open ? 'chevronDown' : 'chevronLeft'} className="h-4 w-4 shrink-0 text-slate-400" />
      </button>
      {open && <p className="px-4 pb-4 text-sm leading-relaxed text-slate-600" data-testid={`${testIdBase}-answer`}>{item.a}</p>}
    </div>
  );
};

export default function HelpCenterPage() {
  useOutletContext();
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return CATEGORIES;
    return CATEGORIES
      .map((cat) => ({ ...cat, items: cat.items.filter((it) => it.q.toLowerCase().includes(q) || it.a.toLowerCase().includes(q)) }))
      .filter((cat) => cat.items.length > 0);
  }, [search]);

  const featured = filtered.filter((c) => c.featured);
  const rest = filtered.filter((c) => !c.featured);

  return (
    <div className="mx-auto max-w-5xl space-y-5" data-testid="help-center-page">
      <PageHead title="مركز المساعدة" desc="كل ما تحتاج معرفته عن استخدام تسيار، منظّم حسب الأقسام" />

      <div className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
        <Icon name="search" className="h-4 w-4 text-slate-400" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="ابحث عن سؤال أو موضوع..."
          className="flex-1 bg-transparent text-sm outline-none"
          data-testid="help-search-input"
        />
      </div>

      {filtered.length === 0 ? (
        <div className="rounded-xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-400" data-testid="help-empty-state">
          لا توجد نتائج مطابقة لبحثك
        </div>
      ) : (
        <div className="space-y-5">
          {featured.length > 0 && (
            <div>
              <h3 className="mb-2 px-1 text-xs font-bold uppercase tracking-wide text-teal-600">الأقسام الأساسية</h3>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                {featured.map((cat) => (
                  <div key={cat.key} className="rounded-xl border-2 border-teal-100 bg-teal-50/40 shadow-sm" data-testid={`help-category-${cat.key}`}>
                    <div className="flex items-center gap-2 border-b border-teal-100 px-4 py-3">
                      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-teal-600 text-white"><Icon name={cat.icon} className="h-4 w-4" /></div>
                      <h4 className="text-sm font-bold text-slate-900">{cat.title}</h4>
                    </div>
                    <div>{cat.items.map((it, i) => <AccordionItem key={i} item={it} testIdBase={`help-item-${cat.key}-${i}`} />)}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {rest.length > 0 && (
            <div>
              <h3 className="mb-2 px-1 text-xs font-bold uppercase tracking-wide text-slate-400">أقسام أخرى</h3>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {rest.map((cat) => (
                  <div key={cat.key} className="rounded-xl border border-slate-200 bg-white shadow-sm" data-testid={`help-category-${cat.key}`}>
                    <div className="flex items-center gap-2 border-b border-slate-100 px-4 py-3">
                      <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#16233b] text-white"><Icon name={cat.icon} className="h-4 w-4" /></div>
                      <h4 className="text-sm font-bold text-slate-900">{cat.title}</h4>
                    </div>
                    <div>{cat.items.map((it, i) => <AccordionItem key={i} item={it} testIdBase={`help-item-${cat.key}-${i}`} />)}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="rounded-xl border border-slate-200 bg-white p-5 text-center" data-testid="help-contact-cta">
        <p className="text-sm text-slate-600">لم تجد ما تبحث عنه؟</p>
        <p className="mt-1 text-xs text-slate-400">افتح أيقونة الدردشة أسفل الشاشة واسأل المساعد الذكي، أو حوّلها إلى تذكرة دعم لفريقنا.</p>
      </div>
    </div>
  );
}
